import { IErrorMessage } from '@hooks/use-error-message.ts';
import { ServiceTypeEnum } from '@models/services.model.ts';

export const servicesErrorMessages: IErrorMessage = {
  name: {
    required: 'validation_name_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  price: {
    required: 'validation_price_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  departmentUnit: {
    required: 'validation_department_unit_required'
  },
  duration: {
    required: 'validation_duration_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  description: {
    required: 'validation_description_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  }
};

export const serviceTypeOptions = [
  { title: 'Reservable', value: 'reservable' },
  { title: 'On Request', value: 'requestable' }
];

export const convertToSelectedDepartmentUnit = (
  data: any | null
): { id: number; title: string; value: string; type?: string }[] => {
  if (!data || !data.departmentUnit) return [];

  const { id, name, type } = data.departmentUnit;

  return [
    {
      id,
      title: name,
      value: name,
      type
    }
  ];
};

export const ServiceStatusMap: Partial<
  Record<ServiceTypeEnum, { text: string; background: string; color: string }>
> = {
  [ServiceTypeEnum.Reservable]: {
    text: 'reservable',
    background: 'var(--blue-alpha-200)',
    color: 'var(--blue-2)'
  },
  [ServiceTypeEnum.Requestable]: {
    text: 'on_request',
    background: 'var(--green-alpha-200)',
    color: 'var(--green)'
  }
};
